"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question: "What services does Sachin Sharma offer?",
    answer:
      "I offer custom software development, mobile app development (Flutter/React Native), web development (React/Next.js), cloud infrastructure (AWS/Docker), and full-stack engineering solutions.",
  },
  {
    question: "What technologies do you specialize in?",
    answer:
      "I specialize in Flutter, React Native, React, Next.js, TypeScript, Node.js, AWS, Docker, and more. I have expertise across mobile, frontend, backend, and DevOps domains.",
  },
  {
    question: "How many years of experience do you have?",
    answer:
      "1.5+ years of professional experience building production-grade applications and leading engineering initiatives.",
  },
  {
    question: "Where are you based?",
    answer:
      "I'm based in Krishan Vihar, Delhi, India. Available for remote work globally.",
  },
];

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-20 px-4 max-w-5xl mx-auto space-y-12">
      <div className="text-center space-y-4">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight">
          Frequently Asked Questions
        </h2>
        <p className="text-sm sm:text-base md:text-xl text-muted-foreground/80 max-w-2xl mx-auto">
          Common questions about my services and expertise
        </p>
      </div>

      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border border-border/40 rounded-2xl overflow-hidden bg-card/20 hover:bg-card/40 backdrop-blur-sm transition-all duration-300 group"
          >
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full px-6 py-5 sm:px-8 sm:py-6 text-left font-bold text-base sm:text-lg flex items-center justify-between group-hover:text-primary transition-colors"
            >
              <span className="flex-1 pr-4">{faq.question}</span>
              <ChevronDown
                className={`w-5 h-5 sm:w-6 sm:h-6 transition-transform duration-500 ease-in-out ${
                  openIndex === index ? "rotate-180" : ""
                } text-muted-foreground group-hover:text-primary`}
              />
            </button>

            {openIndex === index && (
              <div className="px-6 py-6 sm:px-8 sm:py-8 bg-secondary/5 border-t border-border/20 text-muted-foreground/80 text-sm sm:text-base md:text-lg leading-relaxed animate-in slide-in-from-top-2 duration-300">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
